import { AutoCompleteSearchType } from '@libs/trip-planner-interfaces';

export const enum AutoCompleteType {
  Destination = 'destination',
  StartingPosition = 'startingPosition',
  EndingPosition = 'endingPosition',
  Airport = 'airport',
  FerryRoute = 'ferryRoute',
}

export type DestinationAutocompleteType =
  | AutoCompleteType.Destination
  | AutoCompleteType.StartingPosition
  | AutoCompleteType.EndingPosition;

interface AutoCompleteTypeConfig {
  translationKey: string;
  isForPosition: boolean;
  searchType: AutoCompleteSearchType;
}

export const AUTO_COMPLETE_TYPE_CONFIG: Record<
  AutoCompleteType,
  AutoCompleteTypeConfig
> = {
  [AutoCompleteType.Airport]: {
    isForPosition: false,
    searchType: AutoCompleteSearchType.Flight,
    translationKey: 'planner.transport.modal.flight.placeholder',
  },
  [AutoCompleteType.Destination]: {
    isForPosition: false,
    searchType: AutoCompleteSearchType.Destination,
    translationKey: 'planner.search_for_city_or_destination',
  },
  [AutoCompleteType.StartingPosition]: {
    isForPosition: true,
    searchType: AutoCompleteSearchType.MapLocation,
    translationKey: 'planner.choose_starting_point',
  },
  [AutoCompleteType.EndingPosition]: {
    isForPosition: true,
    searchType: AutoCompleteSearchType.MapLocation,
    translationKey: 'planner.choose_end_point',
  },
  [AutoCompleteType.FerryRoute]: {
    isForPosition: false,
    searchType: AutoCompleteSearchType.FerryRoute,
    translationKey: 'planner.transport.modal.ferry.placeholder',
  },
};
